<template>
  <v-dialog
    persistent
    @click:outside="falseButtonClicked()"
    @keydown.esc="falseButtonClicked()"
    v-model="internalShowDialog"
    min-width="500"
    max-width="1204"
  >
    <v-card>
      <v-card-title class="text-title" style="margin-bottom: 0px">
        {{ $t("return_merchandise.heading") }}
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text
        class="dialog-text text-content pa-3"
        color="black"
      >
        <template>
          <v-data-table
            :footer-props="{
              'items-per-page-options': dataTableOptions,
            }"
            :headers="dataHeader"
            :hide-default-footer="true"
            :hide-default-header="true"
            :items="selectedArticles"
            :item-class="row_classes"
            :items-per-page="10000"
            class="elevation-0"
            group-by="group"
            show-group-by
            style="width: 100%"
            disable
          >
            <template v-slot:group.header="{ group }">
              <template v-if="group && group.trim() !== ''">
                <td :colspan="dataHeader.length" class="group-header">
                  <strong>{{ group }}</strong>
                </td>
              </template>
            </template>
            <template #header="{ props: { headers } }">
              <thead class="v-data-table-header">
                <tr>
                  <th
                    v-for="header in headers"
                    :key="header.value"
                    scope="col"
                    class="text-right"
                    :style="getHeaderWidth(header, header.width)"
                  >
                    <template v-if="header.value == 'article_original_name'">
                      <v-row justify="space-between">
                        <v-col class="d-flex" cols="12" sm="2">
                          {{ header.text }}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-else-if="header.value == 'actions'">
                      <v-row justify="space-between">
                        <v-col class="d-flex dontbreakline" cols="12" sm="2">
                          {{ header.text }}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-else>
                      {{ header.text }}
                    </template>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:no-data>
              <span></span>
            </template>

            <template v-slot:item.information="{ item }">
                <v-simple-checkbox
                    class="mt-0 ma-0 pa-0 pl-2"
                    hide-details="auto"
                    v-model="item.is_return_requested"
                    :ripple="false"
                    color="primary"
                ></v-simple-checkbox>
            </template>
            <template v-slot:item.article_original_name="{ item }">
              <v-row
                @mouseover="toggleElementById(item.srno, 'visible', 'return')"
                @mouseleave="toggleElementById(item.srno, 'hidden', 'return')"
              >
                <v-col cols="12" sm="12" style="display: flex">
                  <div class="" style="width: 100%">
                    <template
                      v-if="
                        item.article_original_name &&
                        item.article_original_name.title_description.length > 0
                      "
                    >
                      <div class="cursor-pointer-trans">
                        <span>
                          {{
                            item.article_original_name.title_description[0]
                              .description
                          }}<br />
                          <span class="article_identifier">
                            <TextComponentWithExtraIcons
                              :value="item.article_original_name.identifier"
                            ></TextComponentWithExtraIcons>
                          </span>
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="article_identifier" v-html="item.text"></div>
                    </template>
                  </div>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.quantity="{ item }">
              <v-row
                @mouseover="toggleElementById(item.srno, 'visible', 'return')"
                @mouseleave="toggleElementById(item.srno, 'hidden', 'return')"
              >
                <!-- <v-col cols="12" sm="12">
                  <template v-if="item.quantity">
                    <span>
                      {{
                        fixDecimal(
                          item.quantity,
                          item
                            ? item.article_original_name
                              ? item.article_original_name.family
                                  .quantity_decimals
                              : 0
                            : 0
                        )
                      }}
                      {{ item.selectedmu.value }}
                    </span>
                  </template>
                </v-col> -->
                    <v-col class="pa-0 ma-0 mr-n4" style="width: 10px">
                        <v-combobox
                        style="
                            width: 55px;
                            background-color: gainsboro;
                            z-index: 4;
                        "
                        append-icon=""
                        class="mt-0 shrink"
                        :autocomplete="autocompleteValueLocal"
                        v-model="item.selectedmu"
                        :items="mus"
                        item-text="value"
                        v-on:keydown.enter.prevent=""
                        outlined
                        dense
                        disabled
                        hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col class="pa-0 ma-0 mr-4">
                        <custom-money-input
                        :autocomplete="autocompleteValueLocal"
                        :disabled="isRecalculatingTableData"
                        class="pt-0 to-upper right-aligned-input shrink"
                        hide-details="auto"
                        outlined
                        dense
                        tabindex="2"
                        ref="tableQuantity"
                        v-model="item.display_return_quantity"
                        @input="updateReturnQuantity(item)"
                        v-bind:properties="{
                            readonly: false,
                            disabled: false,
                            outlined: true,
                            placeholder: selectedFamilyArticle
                            ? selectedFamilyArticle.quantity_decimals > 0
                                ? makeZeros(
                                    selectedFamilyArticle.quantity_decimals
                                )
                                : '0'
                            : '0',
                            dense: true,
                            hideDetails: 'auto',
                        }"
                        v-bind:options="{
                            locale: userLanguageId,
                            length: 12,
                            precision: selectedFamilyArticle
                            ? selectedFamilyArticle.quantity_decimals > 0
                                ? selectedFamilyArticle.quantity_decimals
                                : 0
                            : 0,
                            empty: selectedFamilyArticle
                            ? selectedFamilyArticle.quantity_decimals > 0
                                ? makeZeros(
                                    selectedFamilyArticle.quantity_decimals
                                )
                                : '0'
                            : '0',
                        }"
                        />
                    </v-col>
              </v-row>
            </template>
            <template v-slot:item.rounded_unit_price="{ item }">
              <v-row
                @mouseover="toggleElementById(item.srno, 'visible', 'return')"
                @mouseleave="toggleElementById(item.srno, 'hidden', 'return')"
              >
                <v-col cols="12" sm="12">
                  <span
                    v-if="billType && billType.key == 'credit_note'"
                    class="text-no-wrap"
                  >
                    <!-- {{ item.rounded_unit_price ? (parseFloat(item.rounded_unit_price) * parseInt(creditNoteMultiplicationValue.value)).toFixed(getDecimalNumber()) : (0).toFixed(getDecimalNumber()) }} -->
                    {{ currencySymbol }}
                    {{
                      parseFloat(item.rounded_unit_price).toFixed(
                        getDecimalNumber()
                      )
                    }}
                  </span>
                  <span v-else class="text-no-wrap">
                    {{ currencySymbol }}
                    {{
                      item.rounded_unit_price
                        ? parseFloat(item.rounded_unit_price).toFixed(
                            getDecimalNumber()
                          )
                        : (0).toFixed(getDecimalNumber())
                    }}
                  </span>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.red_percentage="{ item }">
              <v-row
                @mouseover="toggleElementById(item.srno, 'visible', 'return')"
                @mouseleave="toggleElementById(item.srno, 'hidden', 'return')"
              >
                <v-col cols="12" sm="12">
                  <span>
                    {{
                      (item.red_percentage ? item.red_percentage : 0).toFixed(
                        getDecimalNumber()
                      )
                    }}
                  </span>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.tva="{ item }">
              <v-row
                @mouseover="toggleElementById(item.srno, 'visible', 'return')"
                @mouseleave="toggleElementById(item.srno, 'hidden', 'return')"
              >
                <v-col cols="12" sm="12">
                  <span>
                    {{ (item.tva ? item.tva : 0).toFixed(getDecimalNumber()) }}
                  </span>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.thtva="{ item }">
              <v-row
                @mouseover="toggleElementById(item.srno, 'visible', 'return')"
                @mouseleave="toggleElementById(item.srno, 'hidden', 'return')"
              >
                <v-col cols="12" sm="12">
                  <span v-if="billType && billType.key == 'credit_note'">
                    <!-- {{ ((item.total ? item.total : 0) * parseInt(creditNoteMultiplicationValue.value)).toFixed(getDecimalNumber()) }} -->
                    {{ item.thtva.toFixed(getDecimalNumber()) }}
                  </span>
                  <span v-else>
                    {{
                      (item.thtva ? item.thtva : 0).toFixed(getDecimalNumber())
                    }}
                  </span>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.total="{ item }">
              <v-row
                @mouseover="toggleElementById(item.srno, 'visible', 'return')"
                @mouseleave="toggleElementById(item.srno, 'hidden', 'return')"
              >
                <v-col cols="12" sm="12">
                  <span
                    v-if="billType && billType.key == 'credit_note'"
                    class="text-no-wrap"
                  >
                    <!-- {{ ((item.total ? item.total : 0) * parseInt(creditNoteMultiplicationValue.value)).toFixed(getDecimalNumber()) }} -->
                    {{ currencySymbol }}
                    {{ item.total.toFixed(getDecimalNumber()) }}
                  </span>
                  <span v-else class="text-no-wrap">
                    {{ currencySymbol }}
                    {{
                      (item.total ? item.total : 0).toFixed(getDecimalNumber())
                    }}
                  </span>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pr-2">
        <v-btn :color="'warning'" @click="printButtonClicked()">
          {{ $t("nav_buttons.print") }}
          <v-icon dark right> mdi-printer </v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-2" @click="falseButtonClicked()">
          {{ $t("attachment.close") }}
          <v-icon dark right> mdi-close </v-icon>
        </v-btn>
        <v-btn :color="'success'" @click="trueButtonClicked()">
          {{ $t("attachment.close") }}
          <v-icon dark right> mdi-content-save </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";
import billMixin from "@/mixins/billMixin";
import CutsomMoneyInput from "@/components/CustomInputs/MoneyInput";

export default {
  mixins: [billMixin],
  components: {
    // 
    "custom-money-input": CutsomMoneyInput,
  },
  props: {
    data: {
      type: Array,
      default: Array,
    },
    showDialog: [Boolean],
  },
  data() {
    return {
      internalShowDialog: this.showDialog,
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      mus: [],

      selectedBill: null,
      selectedArticles: JSON.parse(JSON.stringify(this.data)) ?? [],
      unit_price: 0.0,
      quantity: 4,
      red_percentage: 0.0,
      rowNumber: 0,
      articleTHTVATotal: 0.0,
      articleTHTVATotalBeforeReduction: 0.0,
      articleTotal: 0.0,
      articleTotalBeforeReduction: 0.0,
      total_reduction: 0.0,
      reduction_on_order: 0,
      billType: null,
      dataHeader: [
        {
          text: "",
          align: "right",
          width: "10px",
          sortable: false,
          value: "information",
        },
        {
          text: this.$t("scheduler.article"),
          align: "start",
          width: 65,
          sortable: true,
          value: "article_original_name",
        },
        {
          text: this.$t("scheduler.quantity"),
          align: "end",
          width: 10,
          sortable: true,
          value: "quantity",
        },
        // { text: this.$t('scheduler.unit_price'),           align: 'end',    width:80,  sortable: false,         value: 'unit_price' },
        {
          text: this.$t("billings.unit_price"),
          align: "end",
          width: 2,
          sortable: false,
          value: "rounded_unit_price",
        },
        {
          text: this.$t("scheduler.red_percentage"),
          align: "end",
          width: 2,
          sortable: false,
          value: "red_percentage",
        },
        // { text: this.$t('scheduler.tarrif'),               align: 'end',    width:100,  sortable: false,         value: 'tarrif' },
        {
          text: this.$t("scheduler.tva"),
          align: "end",
          width: 2,
          sortable: false,
          value: "tva",
        },
        {
          text: this.$t("scheduler.thtva"),
          align: "end",
          width: 2,
          sortable: false,
          value: "thtva",
        },
        {
          text: this.$t("scheduler.total"),
          align: "end",
          width: 5,
          sortable: false,
          value: "total",
        },
      ],
    };
  },
  async mounted() {
    await this.getMeasurementUnits();
    this.initializeReturnQuantities();
  },
  computed: {
    currencySymbol() {
      let symbol = null;
      if (this.$store.state.topCurrencyType) {
        symbol = this.parseSymbol(
          this.$store.state.topCurrencyType.symbol ?? ""
        );
        return symbol;
      }
      return symbol ?? "";
    },
  },
  methods: {
    async getMeasurementUnits() {
      await this.getCodes("measurement_units", "measurement_units").then(
        (data) => {
          this.mus = data;
          this.mus = this.mus.sort(function (a, b) {
            if (a.text < b.text) {
              return -1;
            }
            if (a.text > b.text) {
              return 1;
            }
            return 0;
          });
        }
      );
    },
    row_classes() {
      return "articles_row_item";
    },
    falseButtonClicked() {
      this.$emit("update:showDialog", false);
      this.internalShowDialog = false;
    },
    async trueButtonClicked() {
      this.$emit("update:data", this.selectedArticles ?? []);
      this.$emit("update:showDialog", false);
      this.$emit("returnRequested", true);
      this.internalShowDialog = false;
    },
    async printButtonClicked() {
      this.$emit("update:data", this.selectedArticles ?? []);
      this.$emit("update:showDialog", false);
      this.$emit("returnRequestedPrint", true);
      this.internalShowDialog = false;
    },
    resetPage() {
    //   this.appointmentData = null;
    },
    initializeReturnQuantities() {
      // Initialize display_return_quantity with quantity if return_requested_quantity is 0
      this.selectedArticles.forEach(item => {
        if (!item.return_requested_quantity || item.return_requested_quantity == 0) {
          item.display_return_quantity = item.quantity;
          item.return_requested_quantity = item.quantity;
        } else {
          item.display_return_quantity = item.return_requested_quantity;
        }
        console.log("item: ", item, item.display_return_quantity);
      });
    },
    updateReturnQuantity(item) {
      // Update return_requested_quantity when display_return_quantity changes
      item.return_requested_quantity = item.display_return_quantity;
    },
  },
  watch: {
    selectedArticles: {
      handler() {
        // Re-initialize when items change
        this.initializeReturnQuantities();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>

.right-aligned-input >>> input {
  text-align: right;
}

.loading_content {
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
